    import React, { useState } from 'react';
    import { useNavigate } from 'react-router-dom';

    function AwsApplications() {
    const navigate = useNavigate();
    const [modal, setModal] = useState({ open: false, projectIdx: 0, imgIdx: 0 });
    const [slideIdx, setSlideIdx] = useState({}); // { [projectIdx]: imgIdx }

    // Apply theme synchronously to prevent flash
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
        const isDarkMode = document.documentElement.classList.contains('dark-mode');
        if (savedTheme === 'dark' && !isDarkMode) {
        document.documentElement.classList.add('dark-mode');
        } else if (savedTheme === 'light' && isDarkMode) {
        document.documentElement.classList.remove('dark-mode');
        }
    }

    const toggleTheme = () => {
        const isDarkMode = document.documentElement.classList.toggle('dark-mode');
        localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    };

    const projects = [
        {
        title: 'Equation Live',
        description: 'The bulk of the project is build in javascript for the chrome extension but their is still a complex backend handeling user payments and user data.',
        images: ['/static/images/backend.png', '/static/images/aws-example2.png'],
        },
        {
        title: 'Portfilio Website',
        description: 'My first website built with React and AWS. This is a portfolio website that showcases my projects and skills.',
        images: ['/static/images/aws-example2.png', '/static/images/aws-example1.png'],
        },
        {
        title: 'DoveDuo',
        description: 'Project description goes here.',
        images: ['/static/images/aws-example1.png'],
        },
    ];

    // Slideshow navigation
    const handlePrev = (projectIdx) => {
        setSlideIdx((prev) => {
        const cur = prev[projectIdx] || 0;
        return { ...prev, [projectIdx]: (cur - 1 + projects[projectIdx].images.length) % projects[projectIdx].images.length };
        });
    };
    const handleNext = (projectIdx) => {
        setSlideIdx((prev) => {
        const cur = prev[projectIdx] || 0;
        return { ...prev, [projectIdx]: (cur + 1) % projects[projectIdx].images.length };
        });
    };

    // Modal navigation
    const openModal = (projectIdx, imgIdx) => setModal({ open: true, projectIdx, imgIdx });
    const closeModal = () => setModal({ open: false, projectIdx: 0, imgIdx: 0 });
    const modalPrev = () => setModal((m) => ({ ...m, imgIdx: (m.imgIdx - 1 + projects[m.projectIdx].images.length) % projects[m.projectIdx].images.length }));
    const modalNext = () => setModal((m) => ({ ...m, imgIdx: (m.imgIdx + 1) % projects[m.projectIdx].images.length }));

    // Keyboard navigation for modal
    React.useEffect(() => {
        if (!modal.open) return;
        const handler = (e) => {
        if (e.key === 'ArrowLeft') modalPrev();
        if (e.key === 'ArrowRight') modalNext();
        if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
        // eslint-disable-next-line
    }, [modal.open, modal.imgIdx, modal.projectIdx]);

    return (
        <div className="App">
        <nav className="main-nav">
            <div className="nav-left">
            <div className="headshot-container">
                <img
                src="/static/images/profile-picture.png"
                alt="Profile"
                className="headshot"
                onClick={() => navigate('/')}
                />
            </div>
            <div className="nav-logo">Robert Study</div>
            </div>
            <div className="nav-links">
            <a onClick={() => navigate('/')}>Back to Home</a>
            </div>
        </nav>

        <section className="hero-section">
            <div className="hero-content" style={{
            display: 'flex',
            gap: '2rem',
            alignItems: 'flex-start',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 2rem',
            }}>
            <div className="hero-text-content" style={{ flex: '1' }}>
                <h1>AWS <span className="highlight">Applications</span></h1>
                <p className="hero-text">
                A showcase of cloud projects and solutions I've built using AWS.
                </p>
                <p className="hero-text">
                Here you can highlight your experience with AWS services, cloud architecture, automation, and more. Add as many paragraphs as you like to describe your journey and expertise.
                </p>
            </div>
            <div style={{
                flex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: '600px',
                minWidth: '220px',
            }}>
                <img
                src="/static/images/aws2.png"
                alt="AWS Logo"
                style={{
                    width: '100%',
                    height: 'auto',
                    maxWidth: '600px',
                    borderRadius: '16px',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.13)',
                    objectFit: 'contain',
                    background: 'var(--bg-color)'
                }}
                />
            </div>
            </div>
        </section>

        <section className="project-timeline-section" style={{
            position: 'relative',
            maxWidth: '1400px',
            margin: '0 auto',
            padding: '2.5rem 0 3.5rem 0',
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem', position: 'relative', zIndex: 1 }}>
            {projects.map((project, idx) => {
                const curIdx = slideIdx[idx] || 0;
                return (
                <div
                    key={idx}
                    className="aws-project-card"
                    style={{
                    display: 'flex',
                    flexDirection: idx % 2 === 0 ? 'row' : 'row-reverse',
                    alignItems: 'stretch',
                    background: 'var(--bg-color)',
                    borderRadius: '18px',
                    boxShadow: '0 6px 24px var(--nav-shadow)',
                    overflow: 'hidden',
                    transition: 'box-shadow 0.3s',
                    flexWrap: 'wrap',
                    maxWidth: '1200px',
                    width: '100%',
                    margin: '0 auto',
                    padding: 0,
                    }}
                >
                    {/* Image slideshow section */}
                    <div style={{
                        flex: '1 1 400px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'var(--light-bg)',
                        padding: '2.5rem 2rem',
                        minWidth: 0,
                        position: 'relative',
                        flexDirection: 'column',
                        minHeight: '400px',
                        height: '400px',
                    }}>
                        <div style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            maxWidth: '500px',
                        }}>
                            <img
                                src={project.images[curIdx]}
                                alt={project.title}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    maxWidth: '500px',
                                    maxHeight: '300px',
                                    borderRadius: '14px',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.13)',
                                    objectFit: 'contain',
                                    background: 'var(--bg-color)',
                                    cursor: 'pointer',
                                    transition: 'box-shadow 0.2s',
                                }}
                                onClick={() => openModal(idx, curIdx)}
                            />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1.5rem', marginTop: '1rem' }}>
                            <button onClick={() => handlePrev(idx)} aria-label="Previous image" style={{
                                background: 'rgba(0,0,0,0.08)', border: 'none', borderRadius: '50%', width: 36, height: 36, cursor: 'pointer', fontSize: 22
                            }}>&#8592;</button>
                            <span style={{ fontSize: 15, color: 'var(--accent-color)', minWidth: 40, textAlign: 'center' }}>{curIdx + 1} / {project.images.length}</span>
                            <button onClick={() => handleNext(idx)} aria-label="Next image" style={{
                                background: 'rgba(0,0,0,0.08)', border: 'none', borderRadius: '50%', width: 36, height: 36, cursor: 'pointer', fontSize: 22
                            }}>&#8594;</button>
                        </div>
                    </div>
                    {/* Content section */}
                    <div style={{
                        flex: '1.3 1 500px',
                        padding: '2rem 1.5rem',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        minWidth: 0,
                    }}>
                        <h2 style={{ marginBottom: '0.5rem', fontSize: '1.7rem', fontWeight: 700 }}>{project.title}</h2>
                        <p style={{ marginBottom: 0, color: 'var(--text-color)', lineHeight: 1.6 }}>{project.description}</p>
                    </div>
                </div>
                );
            })}
            </div>

            {/* Responsive styles for mobile: stack image/content vertically */}
            <style>{`
            @media (max-width: 900px) {
                .aws-project-card {
                flex-direction: column !important;
                max-width: 98vw !important;
                }
                .aws-project-card > div {
                padding: 2rem 1.2rem !important;
                max-width: 100% !important;
                }
                .aws-project-card img {
                max-width: 100% !important;
                }
                .aws-project-modal-img {
                max-width: 96vw !important;
                max-height: 80vh !important;
                }
            }
            `}</style>

            {/* Modal popup for image slideshow */}
            {modal.open && (
            <div
                style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.85)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background 0.2s',
                }}
                onClick={closeModal}
            >
                <button onClick={(e) => { e.stopPropagation(); modalPrev(); }} aria-label="Previous image" style={{
                position: 'absolute', left: 30, top: '50%', transform: 'translateY(-50%)', zIndex: 10001,
                background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: '50%', width: 48, height: 48, cursor: 'pointer', fontSize: 32, color: '#fff'
                }}>&#8592;</button>
                <img
                src={projects[modal.projectIdx].images[modal.imgIdx]}
                alt="Project large"
                className="aws-project-modal-img"
                style={{
                    maxWidth: '70vw',
                    maxHeight: '80vh',
                    borderRadius: '18px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
                    background: 'var(--bg-color)',
                    objectFit: 'contain',
                    transition: 'box-shadow 0.2s',
                    outline: '3px solid var(--secondary-color)',
                }}
                onClick={e => e.stopPropagation()}
                />
                <button onClick={(e) => { e.stopPropagation(); modalNext(); }} aria-label="Next image" style={{
                position: 'absolute', right: 30, top: '50%', transform: 'translateY(-50%)', zIndex: 10001,
                background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: '50%', width: 48, height: 48, cursor: 'pointer', fontSize: 32, color: '#fff'
                }}>&#8594;</button>
                <button onClick={closeModal} aria-label="Close" style={{
                position: 'absolute', top: 30, right: 30, zIndex: 10001,
                background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: '50%', width: 40, height: 40, cursor: 'pointer', fontSize: 22, color: '#fff'
                }}>✕</button>
                <div style={{ position: 'absolute', bottom: 40, left: 0, right: 0, textAlign: 'center', fontSize: 16, color: '#fff', letterSpacing: 1 }}>
                {modal.imgIdx + 1} / {projects[modal.projectIdx].images.length}
                </div>
            </div>
            )}
        </section>

        <footer style={{
            backgroundColor: 'var(--bg-color)',
            color: 'var(--text-color)',
            padding: '1.5rem',
            textAlign: 'center',
            borderTop: '1px solid var(--accent-color)',
            marginTop: '2rem'
        }}>
            <p style={{
            fontSize: '0.9rem',
            opacity: '0.8'
            }}>
            © {new Date().getFullYear()} Robert Study. All rights reserved.
            </p>
        </footer>

        <button onClick={toggleTheme} className="theme-toggle">
            <span className="light-icon">Light Mode</span>
            <span className="dark-icon">Dark Mode</span>
        </button>
        </div>
    );
    }

    export default AwsApplications; 